import './revenueCards.css';

function RevenueCards({ data }) {
    return (
        <div className='cards-container'>
            <div className='card'>
                <h3>Total Revenue</h3>
                <p>₹{data.totalRevenue}</p>
            </div>

            <div className='card'>
                <h3>This Month</h3>
                <p>₹{data.monthRevenue}</p>
            </div>

            <div className='card'>
                <h3>Pending Payout</h3>
                <p>₹{data.pendingPayout}</p>
            </div>

            <div className='card'>
                <h3>Total Trips</h3>
                <p>{data.totalTrips}</p>
            </div>
        </div>
    );
}

export default RevenueCards;
